import debounce from 'lodash.debounce';
import { Selection, NodeSelection, TextSelection, PluginKey, Plugin } from 'prosemirror-state';
import { DecorationSet, Decoration } from 'prosemirror-view';
import { CommonExtension } from '../../../core/index.js';
import 'prosemirror-model';
import { gapCursorSituation, GapCursor } from '../../../citadel/kit/GapcursorSelection/index.js';
export { GapCursor, gapCursorSituation } from '../../../citadel/kit/GapcursorSelection/index.js';
import 'prosemirror-commands';
import 'prosemirror-inputrules';

/**
 * 统一样式前缀
 */ var CLASSNAME_PREFIX = "ct";

var classNamePrefix = function(className) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : CLASSNAME_PREFIX;
    return "".concat(prefix, "-").concat(className);
};
var domAtPos = function(view, pos, side) {
    var res = view.domAtPos(pos, side);
    if (res === null) {
        return null;
    }
    var node = res.node;
    var offset = res.offset;
    while(node && node.childNodes[offset]){
        var _dom_classList;
        var dom = node.childNodes[offset];
        if ((_dom_classList = dom.classList) === null || _dom_classList === void 0 ? void 0 : _dom_classList.contains("ProseMirror-widget")) {
            offset++;
            continue;
        }
        return dom;
    }
    return null;
};

function styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") {
        return;
    }
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
        } else {
            head.appendChild(style);
        }
    } else {
        head.appendChild(style);
    }
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }
}

var css_248z = '.ProseMirror-gapcursor{display:none;pointer-events:none;position:absolute;z-index:2}.ProseMirror-gapcursor:after{content:"";display:inline-block;height:100%;vertical-align:baseline;position:absolute;bottom:0;border-left:1px solid #000;-webkit-animation:ProseMirror-cursor-blink 1.1s steps(2,start) infinite;animation:ProseMirror-cursor-blink 1.1s steps(2,start) infinite}.ProseMirror-focused .ProseMirror-gapcursor{display:inline-block}.fake-cursor{position:absolute;left:0;width:1px;height:1px;outline:none;background:transparent;z-index:55555}@-webkit-keyframes ProseMirror-cursor-blink{to{visibility:hidden}}@keyframes ProseMirror-cursor-blink{to{visibility:hidden}}';
styleInject(css_248z);

/**
 * TODO: 节点类型是支持gapcursor的，由于目前部分gapcursor定义存在问题，在不保证修改schema的情况下做一层胶水
 * 后续如果schema统一治理，需要将这段代码考虑优化
 */ var allowGapCursor = function(node) {
    if (!node) {
        return false;
    }
    var allow = node.type.spec.allowGapCursor;
    if (allow) {
        return true;
    }
    var textType = [
        "catalog"
    ];
    return textType.includes(node.type.name);
};

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
// prosemirror-gapcursor 1.1.5
var reactNodeClass = classNamePrefix("node-view-dom");
var PM_GAP_CURSOR_CLASS_NAME = "ProseMirror-gapcursor";
var GAP_CURSOR_MIN_HEIGHT = 14;
var getGapCursorTargetDOM = function(state, getView) {
    var _$from_nodeBefore, _dom_classList;
    var selection = state.selection;
    if (!_instanceof(selection, GapCursor)) {
        return null;
    }
    var gapCursorType = selection.gapCursorType, $from = selection.$from;
    var isGapCursorBeforeNode = gapCursorType === gapCursorSituation.beforeInlineNode || gapCursorType === gapCursorSituation.beforeNode;
    var _$from_nodeBefore_nodeSize;
    var dom = isGapCursorBeforeNode ? getView().nodeDOM($from.pos) : getView().nodeDOM($from.pos - ((_$from_nodeBefore_nodeSize = (_$from_nodeBefore = $from.nodeBefore) === null || _$from_nodeBefore === void 0 ? void 0 : _$from_nodeBefore.nodeSize) !== null && _$from_nodeBefore_nodeSize !== void 0 ? _$from_nodeBefore_nodeSize : 0));
    var targetNode = (dom === null || dom === void 0 ? void 0 : (_dom_classList = dom.classList) === null || _dom_classList === void 0 ? void 0 : _dom_classList.contains(reactNodeClass)) ? dom.firstElementChild : dom;
    // targetDom 必须具有 Element.getBoundingClientRect 方法
    // (https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect)
    // SVGElement 和 HTMLElement 都直接继承自 Element
    // https://developer.mozilla.org/en-US/docs/Web/API/Element
    // https://developer.mozilla.org/en-US/docs/Web/API/SVGElement
    // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement
    var targetDom = _instanceof(targetNode, Element) ? targetNode : null;
    return targetDom;
};
// 需要异步更新 GapCursor 的样式，详见：https://km.sankuai.com/page/1216226222
var updateGapCursorStyle = function(gapCursorDOM, state, getView) {
    var gapCursorType = state.selection.gapCursorType;
    var targetDOM = getGapCursorTargetDOM(state, getView);
    var isTableContainer = false;
    if (!targetDOM) {
        return;
    }
    var dom = targetDOM.parentElement;
    while(dom && window.getComputedStyle(dom).position !== "relative"){
        dom = dom.parentElement;
    }
    if (!dom) {
        dom = getView().dom;
    }
    var _dom_getBoundingClientRect = dom.getBoundingClientRect(), editorTop = _dom_getBoundingClientRect.top, editorLeft = _dom_getBoundingClientRect.left;
    // MARK: 特判2.0文档表格新dom结构 铁峰后续可梳理给出更合适的写法
    if (targetDOM.classList.contains("table-container")) {
        targetDOM = targetDOM.querySelector("table");
        isTableContainer = true;
    }
    var _targetDOM_getBoundingClientRect = targetDOM.getBoundingClientRect(), targetTop = _targetDOM_getBoundingClientRect.top, targetLeft = _targetDOM_getBoundingClientRect.left, targetWidth = _targetDOM_getBoundingClientRect.width, targetHeight = _targetDOM_getBoundingClientRect.height;
    var top = targetTop - editorTop;
    var left = targetLeft - editorLeft;
    if (targetHeight < GAP_CURSOR_MIN_HEIGHT) {
        gapCursorDOM.style.height = "".concat(GAP_CURSOR_MIN_HEIGHT, "px");
        gapCursorDOM.style.top = "".concat(top - GAP_CURSOR_MIN_HEIGHT / 2, "px");
    } else {
        gapCursorDOM.style.height = "".concat(targetHeight, "px");
        gapCursorDOM.style.top = "".concat(top, "px");
    }
    if (gapCursorType === gapCursorSituation.afterInlineNode) {
        gapCursorDOM.style.left = "".concat(left + targetWidth, "px");
    } else if (gapCursorType === gapCursorSituation.afterNode) {
        // 主要考虑可以横向滚动的表格
        if (targetDOM === null || targetDOM === void 0 ? void 0 : targetDOM.parentElement) {
            var offsetLeft = !isTableContainer ? targetDOM.parentElement.offsetLeft : targetDOM.parentElement.parentElement.offsetLeft;
            gapCursorDOM.style.left = "".concat(targetDOM.parentElement.clientWidth < targetWidth ? targetDOM.parentElement.clientWidth + offsetLeft : left + targetWidth, "px");
        }
    } else {
        gapCursorDOM.style.left = "".concat(left, "px");
    }
};
var createGapCursorNode = function(state, getView) {
    var node = document.createElement("div");
    node.className = PM_GAP_CURSOR_CLASS_NAME;
    setTimeout(function() {
        var view = getView();
        if (!view.docView) {
            return;
        }
        updateGapCursorStyle(node, state, getView);
    });
    return node;
};
function getDrawGapCursor(state, getView) {
    if (_instanceof(state.selection, GapCursor) || _instanceof(state.selection, NodeSelection) || state.selection.forEachCell) {
        var isNeedGapCursor = _instanceof(state.selection, GapCursor);
        var gapWidget = Decoration.widget(state.selection.head, createGapCursorNode(state, getView), {
            key: "".concat(Math.random())
        });
        return DecorationSet.create(state.doc, _toConsumableArray(isNeedGapCursor ? [
            gapWidget
        ] : []));
    }
    return null;
}
function handleClickOn(view, pos, node, nodePos, event) {
    if (Math.abs(view.lastClick.x - event.clientX) > 4 || Math.abs(view.lastClick.y - event.clientY) > 4) {
        // 拖动行为不触发点击
        return false;
    }
    var target = event.target;
    if (target.classList.contains(reactNodeClass)) {
        var state = view.state;
        var _target_firstElementChild_getBoundingClientRect = target.firstElementChild.getBoundingClientRect(), left = _target_firstElementChild_getBoundingClientRect.left, right = _target_firstElementChild_getBoundingClientRect.right;
        if (event.clientX < left || event.clientX > right) {
            var isBefore = event.clientX < left;
            view.dispatch(state.tr.setSelection(new GapCursor(state.doc.resolve(nodePos + (isBefore ? 0 : node.nodeSize)), isBefore ? gapCursorSituation.beforeNode : gapCursorSituation.afterNode)));
            return true;
        }
    }
    return false;
}
function handleClick(view, pos, event) {
    var _$adjustedPos_nodeAfter;
    if (!view.editable) return false;
    var $pos = view.state.doc.resolve(pos);
    var target = domAtPos(view, pos);
    // 点击到元素上默认选中，不绘制gapcursor
    if (target && target.contains(event.target)) {
        return false;
    }
    var targetInfo = view.posAtCoords({
        left: event.clientX,
        top: event.clientY
    });
    if (!targetInfo) {
        return false;
    }
    var inside = targetInfo.inside, nearPos = targetInfo.pos;
    var $adjustedPos = $pos;
    var bias = 0;
    if (inside === -1) {
        // 此前判断点击左边界的条件存在缺陷，在学城里存在目录树会导致offsetLeft和预期不一致 ONES 63937624
        var leftOfFirstNode = view.nodeDOM(0).getBoundingClientRect() ? view.nodeDOM(0).getBoundingClientRect().left : view.nodeDOM(0).offsetLeft;
        // 点击左边边界
        if (event.clientX < leftOfFirstNode) {
            var _$pos_nodeAfter, _$pos_nodeAfter1;
            // 涉及到位置相关信息，nodeDOM方法不好覆盖，暂时没有添加单测
            bias = 1;
            if ([
                "paragraph",
                "heading",
                "list_item",
                "task_item"
            ].includes((_$pos_nodeAfter = $pos.nodeAfter) === null || _$pos_nodeAfter === void 0 ? void 0 : _$pos_nodeAfter.type.name)) {
                $adjustedPos = view.state.doc.resolve(pos + 1);
            }
            if ([
                "ordered_list",
                "task_list",
                "bullet_list"
            ].includes((_$pos_nodeAfter1 = $pos.nodeAfter) === null || _$pos_nodeAfter1 === void 0 ? void 0 : _$pos_nodeAfter1.type.name)) {
                $adjustedPos = view.state.doc.resolve(pos + 2);
            }
        } else {
            var _$pos_nodeBefore;
            bias = -1;
            if ([
                "paragraph",
                "heading"
            ].includes((_$pos_nodeBefore = $pos.nodeBefore) === null || _$pos_nodeBefore === void 0 ? void 0 : _$pos_nodeBefore.type.name)) {
                // 点击右边边界
                $adjustedPos = view.state.doc.resolve(pos - 1);
            }
        }
    }
    // TODO：这块逻辑需要统一治理
    if ([
        "list_item",
        "task_item"
    ].includes((_$adjustedPos_nodeAfter = $adjustedPos.nodeAfter) === null || _$adjustedPos_nodeAfter === void 0 ? void 0 : _$adjustedPos_nodeAfter.type.name)) {
        $adjustedPos = view.state.doc.resolve(pos + 1);
    }
    // 点击到单元格内的空白处，矫正位置
    var parent = $adjustedPos.node($adjustedPos.depth);
    if ([
        "cell",
        "header_cell"
    ].includes(parent.type.spec.tableRole) && $adjustedPos.nodeBefore === parent.lastChild && !allowGapCursor(parent.lastChild)) {
        $adjustedPos = Selection.near($pos, -1).$head;
    }
    if (!GapCursor.valid($adjustedPos)) {
        return false;
    }
    if (inside && inside > -1 && inside + 1 === nearPos) {
        if ($adjustedPos.nodeBefore && $adjustedPos.nodeBefore.nodeSize === 1) {
            return false;
        }
    }
    var gapCursorType = GapCursor.getType($adjustedPos, bias);
    if (gapCursorType) {
        // 设置 GapCursor 之前确保 view 是聚焦状态，解决无法点击到代码块前面的问题
        // @see https://km.sankuai.com/page/1227428924
        if (!view.hasFocus()) {
            view.dom.focus();
        }
        view.dispatch(view.state.tr.setSelection(new GapCursor($adjustedPos, gapCursorType)));
        return true;
    }
    if (inside > -1 && NodeSelection.isSelectable(view.state.doc.nodeAt(inside))) {
        return false;
    }
    view.dispatch(view.state.tr.setSelection(TextSelection.near($pos)));
    return true;
}
var handleKeyUp = function(view) {
    var _view_state = view.state, $from = _view_state.selection.$from, selection = _view_state.selection;
    if (!selection.empty) {
        return false;
    }
    var nodeBefore = $from.nodeBefore, nodeAfter = $from.nodeAfter;
    if (nodeBefore && !nodeBefore.isText && nodeBefore.isInline && allowGapCursor(nodeBefore) && nodeBefore.type.name !== "hard_break") {
        view.dispatch(view.state.tr.setSelection(new GapCursor($from, gapCursorSituation.afterInlineNode)));
        return true;
    }
    if (nodeAfter && !nodeAfter.isText && nodeAfter.isInline && nodeAfter.type.spec.allowGapCursor && nodeAfter.type.name !== "hard_break" && !(nodeBefore === null || nodeBefore === void 0 ? void 0 : nodeBefore.isText)) {
        view.dispatch(view.state.tr.setSelection(new GapCursor($from, gapCursorSituation.beforeInlineNode)));
        return true;
    }
    return false;
};
var pluginKey = new PluginKey("gap_cursor");
var GapCursorExtension = /*#__PURE__*/ function(CommonExtension) {
    _inherits(GapCursorExtension, CommonExtension);
    var _super = _createSuper(GapCursorExtension);
    function GapCursorExtension() {
        _classCallCheck(this, GapCursorExtension);
        return _super.apply(this, arguments);
    }
    var _proto = GapCursorExtension.prototype;
    _proto.plugin = function plugin(param) {
        var getView = param.getView;
        return new Plugin({
            key: pluginKey,
            props: {
                decorations: function decorations(state) {
                    return this.getState(state);
                },
                handleClickOn: handleClickOn,
                handleClick: handleClick,
                handleDOMEvents: {
                    keyup: handleKeyUp
                }
            },
            state: {
                init: function init() {
                    return DecorationSet.empty;
                },
                apply: function apply(tr, value, oldState, newState) {
                    return getDrawGapCursor(newState, getView);
                }
            },
            view: function view(editorView) {
                var resizeHandler = debounce(function() {
                    var gapCursorDOM = editorView.dom.querySelector(".".concat(PM_GAP_CURSOR_CLASS_NAME));
                    if (gapCursorDOM) {
                        updateGapCursorStyle(gapCursorDOM, editorView.state, function() {
                            return editorView;
                        });
                    }
                }, 500);
                window.addEventListener("resize", resizeHandler);
                return {
                    destroy: function destroy() {
                        window.removeEventListener("resize", resizeHandler);
                    }
                };
            }
        });
    };
    _createClass(GapCursorExtension, [
        {
            key: "name",
            get: function get() {
                return "gap_cursor";
            }
        }
    ]);
    return GapCursorExtension;
}(CommonExtension);

export { GapCursorExtension, getGapCursorTargetDOM, handleClick, handleClickOn };
//# sourceMappingURL=index.js.map
